import React, { useState, useEffect, useLayoutEffect } from "react";

/** Components */
import {
  TableContainer,
  Paper,
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  TablePagination,
  TableFooter,
  Button,
  Collapse,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  TextField,
  ButtonGroup,
  Tooltip,
  Typography,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { TreeMenu } from "./../../commons/renderTreeMenu.component";
import { FilterBy } from "./../../commons/filter.component";
import ButtonWithAPICallComponent from "../../commons/ButtonWithAPICall.component";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import LoadingProgress from "../../commons/LoadingProgress.component";

/** Icons */
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import RefreshIcon from "@mui/icons-material/Refresh";
import { DeleteDialog } from "../../commons/dialog.component";
import CustomDatePicker from "../../commons/CustomDatePicker";
import AssessmentIcon from "@mui/icons-material/Assessment";

/** Api & Function */
import { getErppt, approveErppt, getCustDebt, postSync, getErpptMenu, getCustomers, getErpptById, deleteErpptCi, getAirport } from "./../../../services/api";
import { fitToColumn, sumOfField, round } from "../../../services/libService";
import { setHeaderTitle } from "../../../store/layoutSlide";
import { moneyFormat } from "../../config";

/** Package */
import moment from "moment";
import dayjs from "dayjs";

/** Hook */
import { useTranslation } from "react-i18next";
import { useParamFilter } from "./../../commons/customHook";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { NumericFormat } from "react-number-format";
import * as XLSX from "xlsx";
import { ExcelIcon } from "../../commons/miscellaneous";
import { useDispatch } from "react-redux";

export default function Erppt() {
  // boiler plate
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const history = useHistory();
  const location = useLocation();
  const { fetchData, filter, data, page, perPage, setPage, setPerPage, total, isAllow, loading } = useParamFilter({ page: 1, per_page: 50 }, getErppt);
  const { id } = useParams();
  // state
  const [treeData, setTreeData] = useState();
  const [isSearchOpen, setSearchOpen] = useState(true);
  const [input, setInput] = useState({
    customer: null,
    start_date: filter.start_date || "",
    end_date: filter.end_date || "",
    chkAvailable: false,
  });

  const handleSearch = () => {
    fetchData((prev) => ({ ...input, customer_id: input.customer?.id, selectedCustomer: null }));
    getErpptMenu().then((res) => {
      setTreeData(res.data);
    });
  };
  const handleClickDownloadCSV = () => {
    const params = {};
    if (input.start_date) params.start_date = input.start_date;
    if (input.end_date) params.end_date = input.end_date;
    if (input.customer) params.customer_id = input.customer.id;
    return getErppt(params);
  };

  const exportExcel = (res) => {
    if (res.code === 200) {
      const arrayData = res.data.map((item) => ({
        // làm thế này để xác định những cột nào định dạng string trong file csv
        ID: item.id,
        "Ngày thực hiện": item.ptp_date ? moment(item.ptp_date).format("DD/MM/YYYY") : "",
        "Số phiếu thu": item.erp_code,
        "Khách hàng": item.customer_name,
        "Tiền tệ": item.currency,
        "Số tiền ghi nhận": +item.amount,
        "Phí giao dịch": +item.add_amount,
        "Số tiền khách thanh toán": +item.apv_amount,
        "Số tiền tồn": +item.rst_amount,
        "Trạng thái": statusTranslate[item.status],
      }));
      const worksheet = XLSX.utils.json_to_sheet(arrayData);
      worksheet["!cols"] = fitToColumn(arrayData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet);
      XLSX.writeFileXLSX(workbook, "erppt.xlsx");
    }
  };

  const handleResponse = (res) => {
    fetchData(filter);
  };
  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN CÁC ĐỢT THANH TOÁN"));
    handleSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChkAvailable = (e) => {
    setInput((prev) => ({ ...prev, chkAvailable: e.target.checked }));
  };
  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <ButtonWithAPICall
            title="Xuất dữ liệu ra file Excel"
            disableSnackbar={() => true}
            response={exportExcel}
            api={handleClickDownloadCSV}
            style={{ display: Boolean(data.length) ? "" : "none" }}
          >
            <ExcelIcon />
          </ButtonWithAPICall>
          <Button onClick={() => history.push("/report/erppt")}>
            <Tooltip title="Báo cáo thanh toán của khách hàng">
              <AssessmentIcon />
            </Tooltip>
          </Button>
          <ButtonWithAPICall title="Cập nhật dữ liệu từ ERP" api={() => postSync({ object: "t1t2" })} variant="outlined">
            <RefreshIcon />
          </ButtonWithAPICall>
          <Button onClick={() => setSearchOpen((prev) => !prev)} variant="outlined">
            <Tooltip title="Thư mục">
              <SearchIcon />
            </Tooltip>
          </Button>
        </ButtonGroup>
      </div>
      <Collapse in={isSearchOpen}>
        <FilterBy
          style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
          getDataFunc={() => getCustomers({ status: 1 })}
          value={input.customer || null}
          onChange={(e, newValue) => setInput((prev) => ({ ...prev, customer: newValue }))}
          label={t("Khách hàng")}
          setDefaultFunc={(option) => setInput((prev) => ({ ...prev, customer: option.find((item) => item.id == filter.customer_id) }))}
          triggerSetDefaultFunc={true}
          setDefaultDependencies={[filter.customer_id]}
        />
        <CustomDatePicker
          format="DD/MM/YYYY"
          label={t("Từ ngày")}
          value={input.start_date}
          onChange={(value) => setInput((prev) => ({ ...prev, start_date: value }))}
          sx={{ minWidth: "200px", margin: "5px" }}
        />
        <CustomDatePicker
          format="DD/MM/YYYY"
          label={t("Đến ngày")}
          value={input.end_date}
          onChange={(value) => setInput((prev) => ({ ...prev, end_date: value }))}
          sx={{ minWidth: "200px", margin: "5px" }}
        />
        <FormControlLabel label="Chưa phân bổ" control={<Checkbox checked={input.chkAvailable} onChange={handleChkAvailable} />} sx={{ marginLeft: 1 }} />

        <Button onClick={handleSearch} style={{ margin: "5px" }} variant="outlined">
          {t("Tìm kiếm")}
        </Button>
      </Collapse>
      <div style={{ display: "flex" }}>
        <TreeMenu
          data={treeData}
          onClick={(query) => {
            fetchData((prev) => ({ ...query, per_page: prev.per_page }));
            setInput({});
          }}
          isExpand={!isSearchOpen}
          onExpand={() => setSearchOpen(false)}
        />
        {loading ? (
          <LoadingProgress />
        ) : (
          <div>
            {input.customer && data.length > 0 && (
              <Typography align="left" style={{ margin: 10 }}>
                Tổng tiền ghi nhận ({data[0].currency}):{" "}
                {sumOfField(data, "apv_amount").toLocaleString(data[0].currency === "USD" ? "ja-JP" : "de-DE", { minimumFractionDigits: data[0].currency === "USD" ? 2 : 0 })}{" "}
              </Typography>
            )}

            <TableContainer component={Paper} sx={{ maxHeight: 800 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center" style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>
                      ID (1)
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>
                      {t("Ngày thực hiện (2)")}
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>
                      {t("Số phiếu thu (3)")}
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>
                      {t("Khách hàng (4)")}
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>
                      {t("Tiền tệ (5)")}
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>
                      {t("Số thực nhận (6)")}
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>
                      {t("Phí giao dịch (7)")}
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>
                      {t("Số ghi nhận thanh toán (8=6+7) ")}
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>
                      {t("Số chưa phân bổ (9)")}
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>
                      {t("Số trả trước (10)")}
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>
                      {t("Số trả thừa (11)")}
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }}>
                      {t("Trạng thái (12)")}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.length ? (
                    data.map((item, index) => (
                      <TableRow key={index} hover style={{ cursor: "pointer" }} onClick={() => history.push(`/erppt/${item.id}${location.search}`)}>
                        <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                          {item.id}
                        </TableCell>
                        <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                          {moment(item.ptp_date).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                          {item.erp_code}
                        </TableCell>
                        <TableCell align="left" style={{ border: "1px solid lightgray" }}>
                          {item.customer_name}
                        </TableCell>
                        <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                          {item.currency}
                        </TableCell>
                        <TableCell align="right" style={{ border: "1px solid lightgray" }}>
                          {moneyFormat(item.amount, item.currency)}
                        </TableCell>
                        <TableCell align="right" style={{ border: "1px solid lightgray" }}>
                          {moneyFormat(item.add_amount, item.currency)}
                        </TableCell>
                        <TableCell align="right" style={{ border: "1px solid lightgray" }}>
                          {moneyFormat(item.apv_amount, item.currency)}
                        </TableCell>
                        <TableCell align="right" style={{ border: "1px solid lightgray" }}>
                          {moneyFormat(item.rst_amount, item.currency)}
                        </TableCell>
                        <TableCell align="right" style={{ border: "1px solid lightgray" }}>
                          {moneyFormat(item.prepaid_amount, item.currency)}
                        </TableCell>
                        <TableCell align="right" style={{ border: "1px solid lightgray" }}>
                          {moneyFormat(item.over_amount, item.currency)}
                        </TableCell>
                        <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                          {statusTranslate[item.status]}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={20}>
                        {t(isAllow ? "Không có dữ liệu" : "No permission")}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination rowsPerPageOptions={[50, 100, 150]} count={total || 0} rowsPerPage={perPage} page={page} onPageChange={setPage} onRowsPerPageChange={setPerPage} />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </div>
        )}
      </div>
      <EditDiaglog key={id} onClose={() => history.push(`/erppt${location.search}`)} onSaveResponse={handleResponse} />
    </div>
  );
}

const EditDiaglog = ({ onClose, onSaveResponse }) => {
  const [t] = useTranslation();
  const [initialData, setInitialData] = useState();
  const { id } = useParams();
  const [newCis, setNewCis] = useState([]);
  const [airport, setAirport] = useState(null);
  // method
  const getData = () => {
    setNewCis([]);
    getErpptById(id).then((res) => {
      if (res.code === 200) setInitialData(res.data);
    });
  };

  // NguyenPH: check hàm này.
  const calculateRSTAmount = () => {
    // tính tiền tồn
    if (!initialData) return;
    let newRSTAmount = parseFloat(initialData.rst_amount || 0);
    // let newRSTAmount = parseFloat(initialData.rst_amount || 0) + parseFloat(initialData.add_amount || 0);
    newCis?.forEach((item) => {
      newRSTAmount -= parseFloat(item?.paid_amount || 0);
    });
    return round(newRSTAmount, initialData.currency === "USD" ? 2 : 0);
  };

  const handleChangeAddAmount = (value) => {
    if (value !== null) setInitialData((prev) => ({ ...prev, add_amount: value.amount, rst_amount: initialData.rst_amount + value.amount, gl641_id: value.id }));
    else setInitialData((prev) => ({ ...prev, rst_amount: initialData.rst_amount - initialData.add_amount, add_amount: 0, gl641_id: null }));
  };

  const handleChangeOverAmount = (value) => {
    setInitialData((prev) => ({ ...prev, over_amount: value }));
  };

  const handleChangePrepaidAmount = (value) => {
    setInitialData((prev) => ({ ...prev, prepaid_amount: value }));
  };
  const handleApprove = () => {
    return approveErppt(id, {
      erp_id: +id,
      ptp_id: initialData.ptp_id,
      ptp_date: initialData.ptp_date,
      add_amount: initialData.add_amount,
      apv_amount: parseFloat(initialData.add_amount || 0) + parseFloat(initialData.amount || 0),
      customer_name: initialData.customer_name,
      customer_id: initialData.customer_id,
      currency: initialData.currency,
      currency_id: initialData.currency_id,
      ptrans: newCis
        .filter((item) => item?.id)
        .map((item) => ({
          tp_type: 1,
          tp_id: item.id,
          tp_code: item.code,
          paid_amount: +item.paid_amount,
        })),
      rst_amount: calculateRSTAmount(),
      gl641_id: initialData.gl641_id,

      /**
       * prepaid_amount: Giá trị trả trước
       * over_amount: Giá trị thanh toán thừa
       */
      over_amount: parseFloat(initialData.over_amount) || 0,
      prepaid_amount: parseFloat(initialData.prepaid_amount) || 0,
    });
  };
  const handleSaveResponse = (res) => {
    if (res.code !== 200) return;
    onSaveResponse?.(res);
    getData();
  };
  const handleDeleteOldCi = (ci_id) => {
    // goi api delete o day
    deleteErpptCi(ci_id).then((res) => {
      if (res.code === 200) {
        getData();
      }
      onSaveResponse?.(res);
    });
  };
  const handleValueChange = (value, indexx) => {
    let newCisValue = [...newCis];
    newCisValue[indexx].paid_amount = value;
    setNewCis(newCisValue);
  };
  // effect
  useEffect(() => {
    if (!id) {
      setInitialData();
      return;
    }
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  useLayoutEffect(() => {
    setNewCis([null]);
  }, [airport]);
  return (
    <Dialog align="center" open={Boolean(initialData)} onClose={onClose} fullWidth maxWidth={false}>
      <DialogTitle>PHÂN BỔ TIỀN THANH TOÁN PHIẾU THU {initialData?.erp_code}</DialogTitle>
      {initialData && (
        <DialogContent>
          <TableContainer>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell align="left">Số tiền ghi nhận:</TableCell>
                  <TableCell align="left" style={{ width: "5%" }}>
                    {initialData?.currency}
                  </TableCell>
                  <TableCell align="right">{moneyFormat(parseFloat(initialData?.add_amount || 0) + parseFloat(initialData?.amount || 0), initialData?.currency)}</TableCell>
                  <TableCell align="left">Phí giao dịch:</TableCell>
                  <TableCell align="left">
                    {initialData.gl641 ? (
                      `${initialData.gl641?.amount.toLocaleString(initialData.gl641?.currency === "USD" ? "ja-JP" : "de-DE")} (${initialData.gl641?.currency}) - ${dayjs(
                        initialData.gl641?.ptp_date
                      ).format("DD/MM/YYYY")} - ${initialData.gl641?.erp_code}`
                    ) : (
                      <Autocomplete
                        options={initialData.added_fee}
                        style={{ width: 400 }}
                        getOptionLabel={(option) =>
                          `${option.id} - ${option.amount.toLocaleString(option.currency === "USD" ? "ja-JP" : "de-DE")} (${option.currency}) - ${dayjs(option.ptp_date).format("DD/MM/YYYY")} - ${
                            option.erp_code
                          }`
                        }
                        onChange={(e, value) => handleChangeAddAmount(value)}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    )}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" style={{ width: "15%" }}>
                    Số tiền có thể phân bổ:
                  </TableCell>
                  <TableCell align="left" style={{ width: "5%" }}>
                    {initialData?.currency}
                  </TableCell>
                  <TableCell align="right" style={{ color: calculateRSTAmount() < 0 ? "red" : "#0288D1", width: "10%" }}>
                    {moneyFormat(calculateRSTAmount(), initialData?.currency)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" style={{ width: "15%" }}>
                    Số tiền trả trước:
                  </TableCell>
                  <TableCell align="left" style={{ width: "5%" }}>
                    {initialData?.currency}
                  </TableCell>
                  <TableCell align="right" style={{ width: "10%" }}>
                    <TextField value={initialData?.prepaid_amount} onChange={(e) => handleChangePrepaidAmount(e.target.value)} />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" style={{ width: "15%" }}>
                    Số tiền trả thừa:
                  </TableCell>
                  <TableCell align="left" style={{ width: "5%" }}>
                    {initialData?.currency}
                  </TableCell>
                  <TableCell align="right" style={{ width: "10%" }}>
                    <TextField value={initialData?.over_amount} onChange={(e) => handleChangeOverAmount(e.target.value)} />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" style={{ width: "15%" }}>
                    Số tiền đã phân bổ:
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ border: "1px solid lightgray" }}>STT</TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }}>Số CI/PN</TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }}>{t("Ngày phát hành")}</TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }}>{t("Ngày thanh toán")}</TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }}>{t("Ngày đến hạn")}</TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }}>{t("Loại tiền")}</TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }}>{t("Số tiền")}</TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {initialData?.cis?.length ? (
                  initialData.cis.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell style={{ border: "1px solid lightgray" }}>{index + 1}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }} width={200}>
                        {item.tp_code}
                      </TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{item?.tp_date && moment(item.tp_date).format("DD/MM/YYYY")}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{item?.ptp_date && moment(item.ptp_date).format("DD/MM/YYYY")}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{item?.tp_duedate && moment(item.tp_duedate).format("DD/MM/YYYY")}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{item?.currency}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }} align="right">
                        {item?.gl_cr?.toLocaleString()}
                      </TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>
                        <ButtonWithAPICall dialogNode={(params) => <DeleteDialog {...params} />} color="error" api={() => handleDeleteOldCi(item.id)}>
                          <DeleteIcon />
                        </ButtonWithAPICall>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell style={{ border: "1px solid lightgray" }} colSpan={20}>
                      {t("Không có dữ liệu")}
                    </TableCell>
                  </TableRow>
                )}
                <TableRow>
                  <TableCell style={{ border: "1px solid lightgray" }} colSpan={6} align="center">
                    Tổng tiền:
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }} colSpan={1} align="right">
                    {[...initialData?.cis, ...newCis].reduce((p, c) => p + (c?.gl_cr || 0), 0)?.toLocaleString()}
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }}></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <br />
          {Boolean(newCis?.length) && (
            <div align="left">
              <b>Thanh toán cho:</b>
              <div>
                <FilterBy
                  label={t("Điểm bán")}
                  style={{ margin: "10px 0" }}
                  getOptionLabel={(option) => `${option.IATA ? `${option.IATA} - ` : ""} ${option.name} `}
                  getDataFunc={() => getAirport({ status: 1 })}
                  value={airport}
                  onChange={(e, newValue) => setAirport(newValue)}
                />
              </div>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>STT</TableCell>
                      <TableCell>Số CI/PN</TableCell>
                      <TableCell>{t("Ngày phát hành")}</TableCell>
                      <TableCell>{t("Ngày thanh toán")}</TableCell>
                      <TableCell>{t("Ngày đến hạn")}</TableCell>
                      <TableCell>{t("Loại tiền")}</TableCell>
                      <TableCell>{t("Số tiền thanh toán")}</TableCell>
                      <TableCell>{t("Số tiền cần thanh toán")}</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {newCis?.map((item, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell width={200}>
                            <FilterBy
                              getDataFunc={() => getCustDebt({ customer_id: initialData?.customer_id, airport: airport?.IATA || undefined })}
                              getDataDependencies={[item?.tp_type, airport]}
                              triggerGetDataFunc={Boolean(item?.tp_type !== 0)}
                              value={item}
                              filter={(item) => !newCis?.map((sub_item) => sub_item?.id).includes(item.id)} // khong duoc chon nhung id da co trong cis roi
                              onChange={(e, newValue) =>
                                setNewCis((prev) =>
                                  prev.map((sub_item, sub_index) =>
                                    sub_index === index
                                      ? newValue == null
                                        ? null
                                        : { ...newValue, paid_amount: Math.min(newValue?.total || 0, calculateRSTAmount() + (sub_item?.paid_amount || 0)) }
                                      : sub_item
                                  )
                                )
                              }
                              getOptionLabel={(option) => option.code || option}
                              sx={{ margin: "0 20px", minWidth: 200 }}
                            />
                          </TableCell>
                          <TableCell>{item?.tp_date && moment(item.tp_date).format("DD/MM/YYYY")}</TableCell>
                          <TableCell>{item?.ptp_date && moment(item.ptp_date).format("DD/MM/YYYY")}</TableCell>
                          <TableCell>{item?.tp_duedate && moment(item.tp_duedate).format("DD/MM/YYYY")}</TableCell>
                          <TableCell>{item?.currency}</TableCell>
                          <TableCell>
                            <NumericFormat
                              style={{ minWidth: 200 }}
                              customInput={TextField}
                              valueIsNumericString={true}
                              type="text"
                              thousandSeparator=","
                              decimalSeparator="."
                              allowedDecimalSeparators={["."]}
                              inputProps={{ style: { textAlign: "right" } }}
                              disabled={!item}
                              value={item?.paid_amount || ""}
                              onValueChange={({ value }) => handleValueChange(value, index)}
                            />
                          </TableCell>
                          <TableCell>{item?.total?.toLocaleString()}</TableCell>
                          <TableCell>
                            <Button color="error" onClick={() => setNewCis((prev) => prev.filter((_, sub_index) => sub_index !== index))}>
                              <DeleteIcon />
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          )}
          {calculateRSTAmount() < 0 ? <div style={{ color: "red" }}>Tổng tiền thanh toán lớn hơn tiền tồn</div> : ""}
          <Button
            style={{ margin: 10 }}
            color="success"
            variant="contained"
            disabled={calculateRSTAmount() <= 0 || (newCis?.length > 0 && !newCis[newCis.length - 1])}
            onClick={() => setNewCis((prev) => [...prev, null])}
          >
            {t("Thêm")}
          </Button>
        </DialogContent>
      )}
      <DialogActions>
        <Button onClick={onClose}>{t("Hủy")}</Button>
        <ButtonWithAPICallComponent variant="contained" api={handleApprove} response={handleSaveResponse}>
          {t("Lưu")}
        </ButtonWithAPICallComponent>
      </DialogActions>
    </Dialog>
  );
};

const statusTranslate = {
  ACTIVATED: "Có hiệu lực",
  DEACTIVATED: "Hết hiệu lực",
  INUSED: "Còn hiệu lực",
  FINISHED: "Hết hạn mức",
  DELETED: "Bị hủy",
};
